<div class="zas-row zas-headline-3">
    {{ division.Name }}
    <div *ngIf="division.ProductVersion" class="product-version">
        Versionsnummer: {{ division.ProductVersion }}
    </div>
</div>
<tracking-text
    label="Bedarf:"
    name="description"
    [data]="division.Demand.Description"
    [validity]="validity"
    target="demand"
    [division]="division"
></tracking-text>
